import {Positions} from '@/utils/positionEnum';

export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const items = (state) => state.items;
export const position = (state) => state.position;
export const pendingTrainerWin = (state) => state.pendingTrainerWin;
export const track = (state) => state.track;
export const buttonVolume = (state) => state.buttonVolume ? state.buttonVolume : 0;
export const musicVolume = (state) => state.musicVolume ? state.musicVolume : 0;
export const steps = (state) => state.position && state.position.steps ? state.position.steps : 0;
export const days = (state) => state.position && state.position.days ? state.position.days : 0;
export const maxSteps = (state) => state.position && state.position.maxSteps ? state.position.maxSteps : 0;
export const trainerHasAction = (state) => !!(state.position && state.position.trainer && state.position.trainer.trainerAction);
export const trainerHasOakAction = (state) => !!(state.position && state.position.trainer && state.position.trainer.oakAction);

const FIGHT_POSITION_TYPES = [
  Positions.FIGHT,
  Positions.FIGHT_TRAINER,
  Positions.FIGHT_TEAM_ROCKET,
  Positions.LEAGUE_FIGHT,
  Positions.MEWTWO_FIGHT,
];

const DUNGEON_POSITION_TYPES = [
  Positions.DUNGEON,
  Positions.DUNGEON_CHALLENGE,
];

// Stejna "jsme prave v nejakem souboji" logika jako isFightMode computed v
// BattleScreen.vue (vc. vnoreneho boss souboje v dungeonu) - sdileno sem
// pres novy getter, aby TeamBottomSheet.vue (guard na nakup skillu v
// popupu s pokemonem, viz docs/superpowers/specs/2026-08-14-teamboard-
// pokemon-popup-trainer-tab-design.md) nemusel stejnou logiku kopirovat
// natvrdo (konvence F1 v CLAUDE.md). BattleScreen.vue se zamerne needituje
// (zustava na svem lokalnim computed, mimo rozsah tehle prace).
//
// Pozor: actualPosition dungeonu muze zustat 'pokemon' i po skonceni boss
// souboje (GoDungeonAction.php ho pri DUNGEON_WIN nereseuje) - proto se
// vnoreny dungeon-boj kontroluje jen pri type DUNGEON/DUNGEON_CHALLENGE,
// stejne jako isDungeonMode v BattleScreen.vue.
export const isFightMode = (state) => {
  const position = state.position;
  if (!position) {
    return false;
  }
  if (FIGHT_POSITION_TYPES.includes(position.type)) {
    return true;
  }
  if (DUNGEON_POSITION_TYPES.includes(position.type)) {
    return !!(position.wild && position.wild.dungeon && position.wild.dungeon.actualPosition === 'pokemon');
  }
  return false;
};
